import { initializePaddle } from '@paddle/paddle-js';

let _paddlePromise = null;

export function getPaddle() {
  if (!_paddlePromise) {

	const token =
	  MMQSHARED.PaddleEnvironment === 'sandbox'
		? MMQSHARED.PaddleClientTokenSandbox
		: MMQSHARED.PaddleClientToken;

	_paddlePromise = initializePaddle({
	  environment: MMQSHARED.PaddleEnvironment,
	  token: token, // client-side token
	});
  }

  return _paddlePromise; // resolves to paddle instance
}